import { ChevronRightIcon, SchoolFillIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { useInquiryUrl } from '@/shared/hooks';
import { Button } from '@/ui_v3';
import { Chip } from '@/ui_v3/components/chip';
const BUDGET_TAGS = ['#디지털 선도학교', '#AI 중점학교 운영', '#학습준비물', '#에듀테크/디지털교육/특수교육', '#늘봄학교 운영', '#교육운영비', '#교육과정 자율운영 예산', '#학생 참여형 수업'];

/**
 * 요금제 Hero 영역 — 플랜 카드 위에 노출되는 "학교 예산" 안내 배너.
 * isKR 전용 (호출부에서 게이팅).
 */
export const SchoolBudgetBanner = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isMobile,
    isTabletSm
  } = useViewport();
  const isUnderTabletSm = isMobile || isTabletSm;
  const {
    openInquiryUrl
  } = useInquiryUrl({
    krUrl: '/embed/sales?type=inquiry'
  });
  return <div className="w-full max-w-[640px] py-sm tablet-sm:max-w-[1280px]" data-sentry-component="SchoolBudgetBanner" data-sentry-source-file="SchoolBudgetBanner.tsx">
      <div className="flex w-full flex-col items-start gap-lg rounded-lg border-2 border-[#A49BFF] bg-default p-lg shadow-md tablet-sm:flex-row tablet-sm:items-center tablet-sm:gap-2xl tablet-sm:p-xl">
        <div className="flex flex-1 flex-col items-start gap-md">
          <div className="flex items-center gap-xs">
            <SchoolFillIcon size={isUnderTabletSm ? 'sm' : 'lg'} className="shrink-0 text-[#5748F2]" data-sentry-element="SchoolFillIcon" data-sentry-source-file="SchoolBudgetBanner.tsx" />
            <h3 className="text-heading-md-bold text-default tablet-sm:text-heading-lg-extrabold">
              <span className="text-[#5748F2]">학교 예산</span>에 맞춰 도입할 수
              있어요
            </h3>
          </div>
          <div className="flex w-full flex-wrap content-center items-center gap-2xs">
            {BUDGET_TAGS.map(tag => <Chip key={tag} size="lg" rounded="full" className="min-h-[32px] border-[#F0F2F6] bg-[rgba(28,27,31,0.04)] text-neutral">
                {tag}
              </Chip>)}
          </div>
        </div>
        <Button variant="contained" intent="alternative" size="md" rightSlot={<ChevronRightIcon size="sm" />} className="w-full shrink-0 tablet-sm:w-auto" onClick={() => {
        logger.track('click_school_budget_inquiry');
        void openInquiryUrl();
      }} data-sentry-element="Button" data-sentry-source-file="SchoolBudgetBanner.tsx">
          {t('common:pricing.schoolBudget.inquiry')}
        </Button>
      </div>
    </div>;
};